import { AuthenticationClient } from '@meltwater/gaf-identity-client';
import { logger } from '../logger';

/**
 * A token provider that leverages the GAF identity client
 * @async
 * @type {tokenProvider}
 * @returns {Promise<Token>} - A token to be used for authentication
 */
export async function gafIdentityClientTokenProvider () {
    const authClient = await AuthenticationClient.getInstance();

    if (authClient !== null) {
        const authToken = await authClient.getToken();
        return authToken;
    }

    logger.warn('Cannot read token information from GAF identity client, because the application has not initialized it.');
    return null;
}
